import {
    Heading,
    Text,
    Collection,
    CheckboxField,
    Flex,
    Button,
    Link,
    Grid,
    View,
  } from "@aws-amplify/ui-react";
  import { MdInfoOutline } from "react-icons/md";
  
  export default function Content({
    clientData,
    subscription,
    profiles,
    selectedProfiles,
    setSelectedProfiles,
    navigate,
    linkedInAuthUrl,
  }) {
    return (
      <>
        <br />
        <br />
        {clientData &&
        clientData.subscriptionPlan &&
        clientData.subscriptionPlan !== "none" ? (
          <>
            <Heading level={4}>Step 3: Add Content</Heading>
            <br />
            {profiles && profiles.length ? (
              <>
                <Heading level={4} textAlign="center">
                  Every post from these profiles will be promoted:
                </Heading>
                <Collection
                  items={profiles}
                  type="list"
                  gap="0.5rem"
                  padding="0.5rem"
                  width="100%"
                  direction="column"
                >
                  {(item, index) => (
                    <View
                      key={item.profileId}
                      border="1px solid #ddd"
                      padding="0.5rem"
                      onClick={() => {
                        if (
                          selectedProfiles.some(
                            (p) => p.profileId === item.profileId
                          )
                        ) {
                          setSelectedProfiles(
                            selectedProfiles.filter(
                              (p) => p.profileId !== item.profileId
                            )
                          );
                        } else {
                          setSelectedProfiles([...selectedProfiles, item]);
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <Grid
                        columnGap="0.5rem"
                        rowGap="0.5rem"
                        templateColumns="50px 50px 1fr 50px"
                        alignItems="center"
                        textAlign="left"
                        className="profile-button"
                      >
                        <CheckboxField
                          checked={selectedProfiles.some(
                            (p) => p.profileId === item.profileId
                          )}
                          onChange={() => {
                            if (
                              selectedProfiles.some(
                                (p) => p.profileId === item.profileId
                              )
                            ) {
                              setSelectedProfiles(
                                selectedProfiles.filter(
                                  (p) => p.profileId !== item.profileId
                                )
                              );
                            } else {
                              setSelectedProfiles([...selectedProfiles, item]);
                            }
                          }}
                        />
                        <img
                          src={item.avatarUrl}
                          style={{ borderRadius: "50%", maxWidth: "50px" }}
                          alt={item.name}
                        />
                        <Text isTruncated={true}>{item.name}</Text>
                        {!item.validated ? (
                          <MdInfoOutline title="Profile validation isn't complete!" />
                        ) : null}
                      </Grid>
                    </View>
                  )}
                </Collection>
              </>
            ) : (
              <Text>
                <br />
                You have no verified profiles. Please add profiles to watch for
                content to be promoted by influencers.
              </Text>
            )}
            <br />
            {subscription &&
              clientData &&
              clientData.payments === "active" &&
              profiles &&
              profiles.length === 0 &&
              (clientData.subscriptionPlan !== "none") ? (
              // If the app is running on 1stinfluencer domain, show LinkedIn sign in
              window.location.hostname.includes("1stinfluencer") ? (
                <img
                  src="/1stinfluencer/linkedin/Sign-In-Small---Default.png"
                  alt="Sign in with LinkedIn"
                  onClick={async () => {
                    const url = await linkedInAuthUrl();
                    window.location.href = url;
                  }}
                  style={{ cursor: "pointer", marginTop: "0.5rem" }}
                  onMouseOver={(e) =>
                    (e.currentTarget.src =
                      "/1stinfluencer/linkedin/Sign-In-Small---Hover.png")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.src =
                      "/1stinfluencer/linkedin/Sign-In-Small---Default.png")
                  }
                  onMouseDown={(e) =>
                    (e.currentTarget.src =
                      "/1stinfluencer/linkedin/Sign-In-Small---Active.png")
                  }
                  onMouseUp={(e) =>
                    (e.currentTarget.src =
                      "/1stinfluencer/linkedin/Sign-In-Small---Default.png")
                  }
                />
              ) : (
                <Button
                  onClick={() => navigate("/addProfile")}
                  marginTop="0.5rem"
                  variation="primary"
                >
                  Add Profile
                </Button>
              )
            ) : null}
          </>
        ) : (
          <Flex justifyContent="center">
            <small>
              <br />
              Unlock with subscription{" "}
              <Link href="" onClick={() => navigate("/billing")}>
                <u>here</u>
              </Link>
              <br />
              <br />
            </small>
          </Flex>
        )}
      </>
    );
  }
  